/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import {
	Flex,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
	Spacer,
	IconButton,
	useDisclosure,
	Icon,
	Box,
	HStack,
	Tag,
	TagLabel,
	TagCloseButton,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuGroup,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { MdSort } from 'react-icons/md'
import CustomMenu from '../../../components/menu'
import { useLoadReferenceFilters } from '../../../hooks/activity.hooks'
import ReferenceList from './reference-list'
import { REFERENCE_TYPE } from './util'
import { useAuthContext } from '../../../context/auth.context'
import { useLanguageContext } from '../../../context/locale.context'
import { dataLayerTagManager } from '../../repository/repo.utils'
import ButtonCTA from '../../../components/globalComponents/button'
import bgImage from '../../../assets/images/opaque_bgImage.png'
import { BiFilterAlt } from 'react-icons/bi'
const ReferenceFileContainer = ({ activity, isOverviewOpen }) => {
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		state: { authData },
	} = useAuthContext()
	const [selectedFilter, setselectedFilter] = useState({
		label: locale['All'],
		Value: 'All',
	})
	const [filterList, setFilterList] = useState([
		{ label: locale['All'], Value: 'All' },
	])

	const { mutate } = useLoadReferenceFilters()
	useEffect(() => {
		mutate(
			{
				workflow_activity_id: activity.activity_id,
			},
			{
				onSuccess: async data => {
					const filters = (data || [])
						?.map(i => {
							if (!!i.tag_type_id) {
								return {
									value: i.tag_type_id,
									label: i.tag_type_name,
								}
							}
						})
						.filter(Boolean)
					setFilterList([
						{
							label: locale['All'],
							value: 'All',
						},
						...filters,
					])
				},
			}
		)
	}, [activity])
	const returnSelectedSort = () => {
		if (Object.keys(selectedFilter).length > 0) {
			let statusName = selectedFilter?.label
			if (statusName !== 'All') {
				return (
					<Tag
						variant='solid'
						bg='yellow.600'
						fontSize='0.875rem'
						color='black'
						borderRadius='17px'
						mt='2'
					>
						<TagLabel>{`Filter by ${statusName}`}</TagLabel>
						<TagCloseButton
							onClick={() => {
								setselectedFilter({})
							}}
						/>
					</Tag>
				)
			}
		}
		return null
	}
	return (
		<Flex
			className={`reference-files-tabs-container`}
			variant='enclosed'
			w='100%'
			backgroundRepeat='no-repeat'
			backgroundPosition='center'
			backgroundSize='cover'
			position='relative'
			backgroundColor='#bbbbbb40'
			backgroundImage={`url(${bgImage})`}
			// maxH={isOverviewOpen ? 'calc(100vh - 300px)' : 'calc(100vh - 80px)'}
			// minH={isOverviewOpen ? 'calc(100vh - 300px)' : 'calc(100vh - 80px)'}
			overflowY='auto'
			flexDirection='column'
		>
			{/* <Tab className={`reference-files-tab-refered-in`}>
						{locale['Refered In']}
					</Tab>
					<Tab className={`reference-files-tab-refered-out`}>
						{locale['Refered Out']}
					</Tab>
					{authData?.asset_type_flag_enable_gantt_chart === 1 &&
					activity?.activity_type_category_id === 11 ? (
						<Tab className={`reference-files-tab-prerequisites`}>
							{locale['Prerequisites']}
						</Tab>
					) : null} */}
			<HStack
				spacing={2}
				width='100%'
				justifyContent='space-between'
				padding='1rem 1rem 0 1rem'
				flexBasis='3%'
			>
				{returnSelectedSort()}
				<Box ml='80%'>
					<Menu variant='requestReferences' size='sm'>
						<MenuButton>
							<Flex alignItems='center' gap='0.5rem'>
								<Icon as={BiFilterAlt} color='brand.700' h='1rem' w='1rem' />
								{locale['Filter']}
							</Flex>
						</MenuButton>
						<MenuList>
							<MenuGroup title='Filter By'>
								{filterList.map(filter => (
									<MenuItem
										key={filter.value}
										onClick={() => {
											setselectedFilter(filter)
										}}
									>
										{filter.label}
									</MenuItem>
								))}
							</MenuGroup>
						</MenuList>
					</Menu>
					{/* <CustomMenu
							className={`reference-files-tab-custom-menu`}
							iconProps={{
								//position: 'absolute',
								right: '40px',
								size: 'sm',
								color: 'brand.700',
								h: '1rem',
								w: '1rem',
							}}
							optionList={filterList}
							selected={selectedFilter}
							onSelect={item => {
								dataLayerTagManager('button_click', {
									viewName: 'Reference Files',
									buttonName: 'Filter',
								})
								setselectedFilter(item)
							}}
							icon={BiFilterAlt}
							buttonText={locale['Filter']}
						/> */}
				</Box>
			</HStack>

			<ReferenceList
				className={`reference-files-tab-refered-in-container`}
				selectedActivity={activity}
				type={REFERENCE_TYPE.INTERNAL}
				filter={selectedFilter}
				listType={null}
			/>
			{/* <TabPanels>
					<TabPanel p={3} className={`reference-files-tab-refered-in-list`}>
						<ReferenceList
							className={`reference-files-tab-refered-in-container`}
							selectedActivity={activity}
							type={REFERENCE_TYPE.INTERNAL}
							filter={selectedFilter}
							listType={null}
						/>
					</TabPanel>
					<TabPanel p={3} className={`reference-files-tab-refered-out-list`}>
						<ReferenceList
							selectedActivity={activity}
							type={REFERENCE_TYPE.EXTERNAL}
							filter={selectedFilter}
							listType={null}
						/>
					</TabPanel>
					<TabPanel p={3} className={`reference-files-tab-prerequisites-list`}>
						<ReferenceList
							className={`reference-files-tab-prerequisites-container`}
							selectedActivity={activity}
							type={REFERENCE_TYPE.INTERNAL}
							filter={selectedFilter}
							listType={'prerequisites'}
						/>
					</TabPanel>
				</TabPanels> */}
		</Flex>
	)
}

export default ReferenceFileContainer
